module.exports = __webpack_public_path__ + "img/podcast_cover.dfeba246.jpg";